const AUSTRALIA_ACCOUNT_NUMBER_FORMAT = '9999999999';
const NEW_ZEALAND_ACCOUNT_NUMBER_FORMAT = '99-9999-9999999-999';

export { AUSTRALIA_ACCOUNT_NUMBER_FORMAT, NEW_ZEALAND_ACCOUNT_NUMBER_FORMAT };
